var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Breadcrumbs',{attrs:{"main":"","title":"Incidents"}}),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('incedent-vue')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }